export { usePrivacy, useUpdatePrivacy } from "./hooks/usePrivacy";
export type { PrivacyData } from "./hooks/usePrivacy";
